module.exports = __webpack_public_path__ + "static/assets/a69f2fdf8d88246cf4c876df42f4efab.png";